import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shared/components/ui/table';
import { OrderStatus } from '@/types/api/order';
import { Money } from '@/types/api/utils';
import { OrderStatusBadge } from './order-status-badge';
import { formatMoney } from '@/utils/shared/Utils';

export type OrderListItem = {
  id: string;
  customer: string;
  status: OrderStatus;
  amount: Money;
  itemCount: number;
};

type MembershipListProp = {
  items: OrderListItem[];
  onRowClick: (orderId: string) => void;
};

export function OrderList({ items, onRowClick }: MembershipListProp) {
  return (
    <Table className="table-fixed">
      <TableHeader>
        <TableRow className="hover:bg-transparent">
          <TableHead>Kund</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Belopp</TableHead>
          <TableHead className="text-right md:text-left">Produkter</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.length > 0 ? (
          items.map((item) => (
            <TableRow
              key={item.id}
              className="hover:cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                onRowClick(item.id);
              }}
            >
              <TableCell className="font-medium">{item.customer}</TableCell>
              <TableCell>
                <OrderStatusBadge status={item.status} />
              </TableCell>
              <TableCell>{formatMoney(item.amount)}</TableCell>
              <TableCell className="text-right md:text-left">{item.itemCount} st</TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={4} className="text-center py-6">
              Inga beställningar hittades
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
